import { call, getContext, select, takeEvery } from 'redux-saga/effects';

import { EXTRACTION_V2 } from 'constants/features';
import { selectAccountUuid } from 'reducers/account/meta';
import { selectAccountFeature } from 'reducers/account/features';
import { reportError } from 'helpers/error-reporting';
import { EVENTS_EXPORT_REQUESTED } from 'actions/exports';
import { promisaga } from 'utils/as-promised';

export function* exportEvents({
  payload: { events, email, startDate, endDate },
}) {
  try {
    const apiKey = yield select(selectAccountUuid);
    const api = yield getContext('rbf');
    const useV2 = yield select(selectAccountFeature, EXTRACTION_V2);

    // the job that actually generates csv's uses jq to parse event batches
    // as such, we must derive a jq-style filter from chart.events

    const filter = events.map(({ source, event, id, stepId }) => ({
      name: event,
      ...(source === 'flow' && { flow_id: id }),
      ...(source === 'checklist' && { checklist_id: id }),
      ...(source === 'pin' && { experience_id: id, step_id: stepId }),
      ...(source === 'mobile' && { experience_id: id }),
    }));

    yield call(api.requestCSVExport, {
      apiKey,
      email,
      startDate,
      endDate,
      filter,
      useV2,
    });
  } catch (error) {
    yield call(reportError, error);
    throw error;
  }
}

export default function* exports() {
  yield takeEvery(EVENTS_EXPORT_REQUESTED, promisaga(exportEvents));
}
